import React from "react";
import { H2, Text, Flex, Button, Container } from "@atoms";

// == Types ================================================================

// == Constants ============================================================

// == Component ============================================================

export default function RestrictedAccess() {
  return (
    <Container>
      <Flex alignItems="center" flexDirection="column" p={5}>
        <H2 color="primary" fontSize={7} mb={4}>
          Oops!
        </H2>
        <Text as="p" fontSize={3} mb={4} textAlign="center">
          We can&apos;t show you this page.
        </Text>
        <Text as="p" fontSize={3} mb={4} textAlign="center">
          This feature is reserved for the team captain.
        </Text>
        <Button as="a" href="/">
          Return Home
        </Button>
      </Flex>
    </Container>
  );
}

// == Styles ===============================================================
